import { Yii } from "libraries/interfaces/Yii";

export const DATE_EXPRESSION_FORM_INTRO: string  = Yii.t('wui-shared-js', "Ce formulaire contient des champs date qui supportent les expressions de type :");

export const DATE_EXPRESSION_FIELD_INTRO : string = Yii.t('wui-shared-js', "Ce champ supporte les expressions de date :");

export const STAY_EXPRESSION_FIELD_INTRO : string = Yii.t('wui-shared-js', "Ce champ supporte les syntaxes :");

export const DATE_EXPRESSION_DETAILS : string[] = [
    Yii.t('wui-shared-js', "aujourd'hui : ="),
    Yii.t('wui-shared-js', "début du mois : <"),
    Yii.t('wui-shared-js', "fin du mois : >"),
    Yii.t('wui-shared-js', "dans cinq jours : +5"),
    Yii.t('wui-shared-js', "dans deux semaines : +2w"),
    Yii.t('wui-shared-js', "dans trois mois : +3m")
];

export const STAY_EXPRESSION_DETAILS : string[] = [
    Yii.t('wui-shared-js', "NOT ou un tiret au début d'un mot pour rechercher des valeurs qui ne contiennent pas ce mot."),
    Yii.t('wui-shared-js', "* pour rechercher un texte partiel."),
    Yii.t('wui-shared-js', "AND pour combiner des expressions"),
];